<template>
  <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>

      <v-card-title class="text-h6">
        <span>
          {{ isEntryMode ? 'Add Market' : 'Update Market' }}
        </span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>

        <v-form @submit.prevent="submit" ref="MarketSetup">

          <v-row>

            <v-col cols="12">

              <v-text-field
                label="Name"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="name.value.value"
                :error-messages="name.errorMessage.value"
                clearable
              >
                <template #label>
                  Name <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <v-textarea
                label="Remarks (Optional)"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="remarks.value.value"
                :error-messages="remarks.errorMessage.value"
                clearable
                auto-grow
                rows="1"
              ></v-textarea>

              <v-checkbox
                label="Active"
                v-model="status.value.value"
                :error-messages="status.errorMessage.value"
                density="compact"
                variant="outlined"
                hide-details
                single-line
                color="primary"
                value="1"
              ></v-checkbox>

              <input
                v-model="market_id.value.value"
                type="hidden"
              >

            </v-col>

          </v-row>

          <v-divider></v-divider>

          <v-card-actions>

            <v-layout class="justify-end">

              <v-btn
                class="bg-red"
                variant="flat"
                type="reset"
                @click="closeDialog"
              >
                Close
              </v-btn>

              <v-btn
                class="bg-brand w-15 ms-2"
                variant="flat"
                type="submit"
              >
                {{ isEntryMode ? 'Save' : 'Update' }}
              </v-btn>

            </v-layout>

          </v-card-actions>

        </v-form>

      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>

import { ref } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'

export default {

  name: 'MarketSetup',

  props: {

    dialog: {
      type: Boolean,
      default: false
    },

    data: {
      type: Object,
      default: () => ({
        name: '',
        remarks: '',
        status: 1,
        market_id: null,
      })
    }
  },

  data() {

    return {
      localDialog: this.dialog,
      errorMessages: '',
      loading: false,
      isEntryMode: true,
    }
  },

  watch: {

    dialog(val) {
      this.localDialog = val
    },

    localDialog(val) {
      this.$emit('update:dialog', val)
    },

    data: {

      handler(newData) {

        this.isEntryMode = !newData.id;

        this.resetForm({
          errors: {},
          touched: {}
        });

        this.name.setValue(newData.name || '', false);

        this.remarks.setValue(newData.remarks || '', false);

        this.status.setValue(
          String(newData.status) || '1',
          false
        );

        this.market_id.setValue(
          newData.id || '',
          false
        );
      },
    }

  },

  methods: {

    updateDialog(val) {
      this.$emit('update:dialog', val)
    },

    closeDialog() {
      this.$emit('update:dialog', false);
    },

  },

  setup(props, { emit }) {

    const { handleSubmit, resetForm } = useForm({

      validationSchema: yup.object({

        name: yup
          .string()
          .min(1)
          .max(100)
          .required()
          .trim()
          .label('Name'),

        remarks: yup
          .string()
          .max(250)
          .nullable()
          .trim()
          .label('Remarks'),

      }),

    });

    const name = useField('name');

    const status = useField('status');

    const market_id = useField('market_id');

    const remarks = useField('remarks');

    const errorMessages = ref('');

    const loading = ref('');

    const store = useStore();

    const submit = handleSubmit((values) => {

      store.dispatch("saveUpdateMarket", values)

        .then((response) => {

          resetForm();

          emit('update:dialog', false);

          toast.success(response.data.message);

          loading.value = true;

          store.dispatch('getMarketList')

            .then(() => {
              loading.value = false;
            })

            .catch((error) => {

              loading.value = false;

              toast.error(error.response.data.message);

            })

        })

        .catch((error) => {

          toast.error(error.response.data.message);

        })

    });

    return {

      submit,
      name,
      status,
      errorMessages,
      market_id,
      resetForm,
      loading,
      remarks

    }

  },

  mounted() {

  }

}
</script>